import { render, staticRenderFns } from "./AppStorePopup.vue?vue&type=template&id=26bfdba7&scoped=true"
import script from "./AppStorePopup.vue?vue&type=script&lang=js"
export * from "./AppStorePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bfdba7",
  null
  
)

export default component.exports